import React, { useState, useEffect } from "react";
import {
  fetchTransactionJSON,
  fetchTransactionDetails,
} from "../services/errorMessageQueue-service";
import Form from "react-bootstrap/Form";
import { useLocation } from "react-router-dom";
import { transactionLogFormatAction } from "../util/common";

const ErrorMessageJSONTab = (props) => {
  const location = useLocation();

  const [jsonMessage, setJsonMessage] = useState(null);
  const [transactionDetails, setTransactionDetails] = useState(null);

  const getTransactionDetails = async () => {
    let transactionId = location.state.transactionId;
    let response = await fetchTransactionDetails(transactionId);

    if (response.ok) {
      let data = await response.json();
      if (Array.isArray(data)) {
        let i = 1;
        let str = data
          .filter((error) => error?.source !== "Exception")
          .map((error) => constructErrorMessage(i++, error))
          .join("\n");
        setTransactionDetails(str);
      }
    } else {
      setTransactionDetails(null);
    }
  };

  const constructErrorMessage = (i, error) => {
    let actionLog = transactionLogFormatAction(error);
    if (error?.source === "Updation") {
      actionLog += ` by ${error?.createdBy || ""}`;
    }
    let sentence = `${i}. ${actionLog}.`;
    return sentence;
  };

  const getTransactionJson = async () => {
    let transactionId = location.state.transactionId;
    let response = await fetchTransactionJSON(transactionId);

    if (response.ok) {
      let data = await response.json();
      setJsonMessage(data);
    } else {
      // setIsError(true);
      // let error = await response.text();
      // setJsonMessage(error?.description);
    }
  };

  useEffect(() => {
    jsonMessage === null && getTransactionJson();
    transactionDetails === null && getTransactionDetails();
  }, []);

  return (
    <>
      <>
        {" "}
        <div className="bold">Transaction Details</div>
        <Form.Control
          as="textarea"
          style={{ minHeight: "12vh" }}
          disabled
          readOnly
          value={
            transactionDetails
              ? transactionDetails
              : "There has been no updates to the HL7 Message."
          }
        />
        <br />
      </>

      <Form.Control
        as="textarea"
        className="tabTxtArea"
        style={{ minHeight: "65vh" }}
        disabled
        readOnly
        value={JSON.stringify(jsonMessage, undefined, 2)}
      />
    </>
  );
};

export default ErrorMessageJSONTab;
